import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchMailConfig,
  saveMailConfig,
  removeMailConfig,
  testMailConfig,
} from "../api/integrations";

// Admin-only read: the caller gates on role, and the flag keeps a
// non-admin mount from ever issuing the request.
export function useMailConfig(enabled: boolean) {
  return useQuery({
    queryKey: ["integrations", "mail"],
    queryFn: fetchMailConfig,
    staleTime: 60_000,
    enabled,
  });
}

// The sender decides what the connections panel can claim about mail, and
// a test send changes it, so both refresh together.
function useMailInvalidation() {
  const queryClient = useQueryClient();
  return async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["integrations", "mail"] }),
      queryClient.invalidateQueries({ queryKey: ["integrations", "status"] }),
    ]);
  };
}

// One mutation key for every write, so the dialog holding the form can
// ask "is a call in flight?" without owning the mutations.
const MAIL_WRITE = ["integrations", "mail"];

export function useSaveMailConfig() {
  const invalidate = useMailInvalidation();
  return useMutation({
    mutationKey: MAIL_WRITE,
    mutationFn: saveMailConfig,
    onSuccess: invalidate,
  });
}

export function useRemoveMailConfig() {
  const invalidate = useMailInvalidation();
  return useMutation({
    mutationKey: MAIL_WRITE,
    mutationFn: removeMailConfig,
    onSuccess: invalidate,
  });
}

export function useTestMailConfig() {
  const invalidate = useMailInvalidation();
  return useMutation({
    mutationKey: MAIL_WRITE,
    mutationFn: testMailConfig,
    onSuccess: invalidate,
  });
}
